import * as Dialog from "@radix-ui/react-dialog";
import styled from "styled-components";
import { Flex } from "../Flex";
export const Overlay = styled(Dialog.Overlay) `
	display: grid;
	place-items: center;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;

	opacity: 0.4;
	background-color: var(--greys-950-80);
`;
export const DialogHeadingContainer = styled(Flex) `
	border-bottom: 1px solid var(--border-primary);

	[data-testid='icon-brightness_alert-24px'] {
		line-height: 0;
	}
`;
export const DialogContainer = styled(Flex) `
	position: fixed;
	top: 50%;
	left: 50%;
	box-shadow: 0px 0px 8px #99999929;
	transform: translate(-50%, -50%);
	z-index: 99999;

	* {
		outline: none;
	}
`;
export const DialogDescriptionContainer = styled(Dialog.Description) `
	position: relative;
	max-height: ${props => props.maxHeight ? props.maxHeight : '392px'};
	/* max-height: 392px; */
	overflow-y: auto;
`;
export const Close = styled(Dialog.Close) `
	padding: 0;
	cursor: pointer;
`;
export const CloseContent = styled(Dialog.Close) `
	position: absolute;
	top: 16px;
	right: 24px;
	padding: 0;
	cursor: pointer;
`;
//# sourceMappingURL=styles.js.map